// extracted by mini-css-extract-plugin
export default {"table_container":"LeaveTrackerTable_table_container__7yvRB","leave_actions_wrapper":"LeaveTrackerTable_leave_actions_wrapper__Nw9LO"};